import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { CREATE_TAGs } from '../../lib/strings';
import { spacing } from '../../lib/theme';
import { Modal, Tag } from 'antd';
import { appleStoreUrl, playStoreUrl, showTagName } from '../../lib/utils';
import TagTile from './TagTile';
import EmptyState from './EmptyState';

class YourTags extends Component {
    // tagClick = (tagName) => {
    //     if (tagName == CREATE_TAGs) {
    //         Modal.info({
    //             title: <h4>Tags</h4>,
    //             content: (
    //                 <div>
    //                     <p>Tags can only be organized through mobile apps (<a href={appleStoreUrl}
    //                         target='_blank' rel="noopener noreferrer">iOS</a> or <a href={playStoreUrl}
    //                             target='_blank' rel="noopener noreferrer">Android</a>) for now. It will be available here soon.</p>
    //                 </div>
    //             ),
    //             onOk() { },
    //         });
    //     }
    // }
    render() {
        const { podcastTags, userDetails } = this.props;
        if (!userDetails || !userDetails.uid) {
            return <EmptyState message={'Please sign in to create collections.'} imageName="empty" />
        }
        let tagNames = []; // Object.keys(podcastTags) || [];
        (Object.keys(podcastTags) || []).forEach(key => {
            const val = podcastTags[key] || {};
            if (val.userID == userDetails.uid) {
                tagNames.push(key);
            }
        })
        // tagNames.push(CREATE_TAGs);
        console.dir(tagNames);
        console.dir(podcastTags);
        return (
            <div>
                <div style={{ marginBottom: `${spacing('xxs')}` }}>
                    {tagNames.sort().map((tagKey, ind) => (
                        <div key={ind}>
                            <TagTile tag={podcastTags[tagKey]} tagName={tagKey} tagId={tagKey} isYou={true} />
                        </div>
                    ))}
                    {/* {tagNames.map(tagName => {
                        return <Tag key={tagName} onClick={this.tagClick.bind(this, tagName)}
                            // color={tagName === _activeTag && `${colors.primary}`}
                            style={{ display: 'inline', cursor: tagName == CREATE_TAGs && 'pointer' }}>
                            {showTagName(tagName)}
                        </Tag>
                    })} */}
                </div>
            </div>
        )
    }
}

YourTags.propTypes = {
    loadingState: PropTypes.object,
    podcastTags: PropTypes.object,
    userDetails: PropTypes.object,
    // getEpisodesRecent: PropTypes.func,
    // getEpisodeReviews: PropTypes.func,
}

const mapStateToProps = (state) => {
    return {
        userDetails: state.userDetails,
        loadingState: state.loadingState,
        podcastTags: state.podcastTags,
    }
}

export default connect(mapStateToProps, null)(YourTags);